// The "Fix" note dialog, shared by the Commission Approvals page and the
// accountant dashboard panel. Pure UI — the caller owns the save.
import React, { useState } from "react";
import { X } from "lucide-react";

export default function FixDealDialog({ deal, busy, onCancel, onSubmit }) {
  const [note, setNote] = useState("");
  if (!deal) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/45 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md p-5">
        <div className="flex items-start justify-between mb-1">
          <h2 className="text-[16px] font-semibold text-slate-900">
            Fix {deal.propertyaddress || "this deal"}
          </h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        <p className="text-[13px] text-gray-500 mb-3">
          Tell the team what needs fixing. The deal keeps moving; this just
          raises a hand.
        </p>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={3}
          placeholder="Example: agent split should be 65%, not 70%"
          className="w-full border border-gray-200 rounded-lg p-3 text-[14px] focus:outline-none focus:border-gray-400"
        />
        <p className="text-[12px] text-gray-400 mt-2 mb-4">
          Alerts whoever approved this deal (or the agent who submitted it),
          plus Henry.
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="text-[13px] rounded-full px-4 py-1.5 border border-gray-200 text-gray-600 hover:border-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(note.trim())}
            disabled={!note.trim() || busy}
            className="text-[13px] rounded-full px-4 py-1.5 bg-amber-500 text-white hover:bg-amber-600 disabled:opacity-50"
          >
            Send Fix Request
          </button>
        </div>
      </div>
    </div>
  );
}
